import React from 'react';
import style from './style.scss'

const Paragraph = (props) => {
    const {field} = props;
    return (
        <div>
            <label
                className={style.formPara}
            >
                <div dangerouslySetInnerHTML={{__html: field.label}}/>
            </label>
           

        </div>
    )
}
export default Paragraph;



